$(document).ready(function () {
  if (!$('body').hasClass('neos-backend')) {
    $('article.section[data-parallax=true]').paroller();
  }
});
